import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import { OrderedMap } from 'immutable';

import UserModel from 'models/user';
import Brand from 'models/brand';

import setDefaultPaymentMethod from 'action-creators/payment-methods/set-default-payment-method';
import deletePaymentMethod from 'action-creators/payment-methods/delete-payment-method';
import trackEvent from 'action-creators/analytics/track-event';

import PaymentMethodsComponent from 'components/payment-methods';

const propTypes = {
  paymentMethods: PropTypes.instanceOf(OrderedMap).isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  app: PropTypes.string.isRequired,
  defaultPaymentMethodId: PropTypes.string,
  setDefaultPaymentMethod: PropTypes.func.isRequired,
  deletePaymentMethod: PropTypes.func.isRequired,
  editPaymentMethod: PropTypes.func.isRequired,
  connectPaymentMethod: PropTypes.func.isRequired,
  newPaymentMethod: PropTypes.func.isRequired,
  newBusinessProfile: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedPaymentMethodId: null,
  defaultPaymentMethodId: null,
  paymentMethod: null,
};

class PaymentMethods extends Component {
  componentDidMount() {
    require('smoothscroll-polyfill').polyfill();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  render() {
    return (
      <PaymentMethodsComponent
        user={this.props.user}
        paymentMethods={this.props.paymentMethods}
        defaultPaymentMethodId={this.props.defaultPaymentMethodId}
        setDefaultPaymentMethod={this.props.setDefaultPaymentMethod}
        deletePaymentMethod={this.props.deletePaymentMethod}
        editPaymentMethod={this.props.editPaymentMethod}
        connectPaymentMethod={this.props.connectPaymentMethod}
        newPaymentMethod={this.props.newPaymentMethod}
        newBusinessProfile={this.props.newBusinessProfile}
        brand={this.props.brand}
        app={this.props.app}
        trackEvent={this.props.trackEvent}
      />
    );
  }
}


PaymentMethods.propTypes = propTypes;
PaymentMethods.defaultProps = defaultProps;

const editPaymentMethod = paymentMethod => push(paymentMethod.editURL);
const connectPaymentMethod = paymentMethod => push(paymentMethod.connectURL);
const newPaymentMethod = () => push('/account/payment-methods/new/');
const newBusinessProfile = () => push('/account/payment-methods/business-profiles/new/');

const mapStateToProps = (state) => {
  const {
    paymentMethods,
    selectedPaymentMethodId,
    defaultPaymentMethodId,
  } = state.paymentMethods;
  const { user } = state.account;
  const { brand } = state.brand;
  const { name: app } = state.app;

  return { paymentMethods, user, selectedPaymentMethodId, defaultPaymentMethodId, brand, app };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    setDefaultPaymentMethod,
    deletePaymentMethod,
    editPaymentMethod,
    connectPaymentMethod,
    newPaymentMethod,
    newBusinessProfile,
    trackEvent,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);
